import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  GroupRoleAssignmentWithRelationsDto,
  ResponseDto,
} from "@mimber/schema"
import { groupRoleAssignmentsKeys } from "../roles.utils"

/**
 * Organization-specific hook for fetching group role assignments for a specific role
 * Can only be used in mimber-organization app
 */
export const useGroupRoleAssignments = (
  roleUuid: string,
  options?: UseQueryOptions<
    ResponseDto<GroupRoleAssignmentWithRelationsDto[]>,
    Error
  >
): UseQueryResult<
  ResponseDto<GroupRoleAssignmentWithRelationsDto[]>,
  Error
> => {
  guardAppUsage("mimber-organization", "useGroupRoleAssignments")

  const { server } = useServerContext()

  return useQuery({
    queryKey: groupRoleAssignmentsKeys.findByRole(roleUuid),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<GroupRoleAssignmentWithRelationsDto[]>
      >(`roles/${roleUuid}/group-assignments`)
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!roleUuid,
    ...options,
  })
}
